module.exports = "//d274d294w9cx2v.cloudfront.net/2807b5fb218acac42c53357ef84d4eb8659c6c0b/images/photo-single.png";